import type { RouteLocationNamedRaw, Router } from 'vue-router'

import { resolveChatMessagingUiEnabled } from '@/shared/composables/user-features'
import { pathNames } from '@/shared/utils/constants'
import { Optional } from '@/shared/utils/optional'

let appRouter: Router | null = null

/** Bound from app router bootstrap to avoid static `@/app/router` import cycles. */
export const setOptionalPushRouter = (router: Router): void => {
  appRouter = router
}

export const optionalPush = async (v: RouteLocationNamedRaw | undefined) => {
  if (!appRouter) {
    throw new Error('Router is not bound for optionalPush')
  }
  const router = appRouter
  await Optional
    .ofNullable(v)
    .ifPresentAsync(async (route: RouteLocationNamedRaw) => {
      if (route.name === pathNames.CHAT && !resolveChatMessagingUiEnabled()) {
        return
      }
      await router.push(route)
    })
}
